var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3816 9.63319C17.3816 4.84579 13.5007 0.964844 8.71326 0.964844C3.92587 0.964844 0.0449219 4.84579 0.0449219 9.63319C0.0449219 14.4206 3.92587 18.3015 8.71326 18.3015C13.5007 18.3015 17.3816 14.4206 17.3816 9.63319Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4035 14.5258V9.88579H10.961L11.1946 8.07747H9.4035V6.92292C9.4035 6.39941 9.54893 6.04261 10.2997 6.04261H11.2573V4.42572C10.7938 4.37669 10.328 4.35293 9.86189 4.35457C8.48124 4.35457 7.53608 5.19725 7.53608 6.74488V8.07747H5.97461V9.88579H7.53608V14.5258H9.4035Z",
    fill: "#2E353D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.720703198732a0ae69d208a4b1c212c6.svg";
export { ForwardRef as ReactComponent };